import React, {useContext, useState} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import {Alert, Button, Form, Input, Typography} from 'antd';

import './login.scss';

import EvenLayout from "../../../layout/evenLayout/evenLayout";
import {login} from "../../../apis/result";
import {getTokenHeader, replaceUrlByParams, setTokenHeader} from "../../../utils/api";
import {PAGE} from "../../../utils/constants";
import {AppContext} from "../../../App";
import Cookies from 'universal-cookie';

function UserLoginPage() {
    let history = useHistory();
    const {pid} = useParams();
    const {Title} = Typography;
    const {appSetting, setLoading} = useContext(AppContext)
    const {checkResultButton, checkResultForm, checkResultSubmit} = appSetting
    const cookies = new Cookies()

    const [state, setState] = useState({
        isErr: false,
        errMsg: ''
    })

    const {isErr, errMsg} = state;

    const onFinish = async (value) => {
        setLoading(true)
        const {adminToken} = getTokenHeader()
        const loginInfo = Object.keys(value).map(i =>{
            return {
                id: i,
                value: value[i]
            }
        })

        try {
            let res = await login(pid, loginInfo);

            if (res.error) {
                throw new Error(`${res.error.msgCode} - ${res.error.message}`);
            } else {
                setTokenHeader(adminToken, res.token);
                cookies.set('publicToken', res.token)
                history.push(`${replaceUrlByParams(PAGE.USER_APPLICATION_DETAIL, {':pid':pid})}`);
            }
        } catch (e) {

            setLoading(false)
            setTokenHeader(adminToken, '');
            setState({...state, isErr: true, errMsg: '申請編號或主要聯絡人電話不正確。'})
        }

    };

    const onFinishFailed = errorInfo => {
        // console.log('Failed:', errorInfo);
    };

    return (
        <EvenLayout
            className='user-login-page'
        >
            <Title level={3} className='title'>{checkResultButton}</Title>
            <div className='login-form-container'>
                {
                    isErr && (
                        <Alert className='err-msg' message={errMsg} type='error' showIcon />
                    )
                }
                <Form
                    layout='vertical'
                    labelAlign='right'
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    hideRequiredMark={true}
                >

                    {
                        checkResultForm.map((field, i) => {
                            return (
                                <Form.Item
                                    key={i}
                                    id={field.id}
                                    label={field.name}
                                    name={field.id}
                                    rules={[{required: true, message: `請輸入${field.name}` }]}
                                >
                                    <Input
                                        placeholder={field.name}
                                    />
                                </Form.Item>
                            )
                        })
                    }

                    <div className='button-container'>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                               {checkResultSubmit }
                            </Button>
                        </Form.Item>
                    </div>
                </Form>
            </div>
        </EvenLayout>
    );
}

export default UserLoginPage;
